import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LicensingPage = lazy(() => import('../pages/licensing/page'));
const CheckoutSuccessPage = lazy(() => import('../pages/checkout/success/page'));
const CheckoutCancelPage = lazy(() => import('../pages/checkout/cancel/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/licensing',
    element: <LicensingPage />,
  },
  {
    path: '/checkout/success',
    element: <CheckoutSuccessPage />,
  },
  {
    path: '/checkout/cancel',
    element: <CheckoutCancelPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;